import type { AnswerInputProps } from '../QuestionRenderer'

export function MatrixInput({
  question,
  value = {},
  onChange,
}: AnswerInputProps<Record<string, string | string[]>>) {
  const rows = question.settings.rows ?? ['項目 1', '項目 2']
  const columns = question.settings.columns ?? ['不同意', '普通', '同意']
  const multiple =
    question.settings.selectionMode === 'multiple' || Boolean(question.settings.allowMultiple)

  function toggle(row: string, column: string) {
    if (!multiple) {
      onChange({ ...value, [row]: column })
      return
    }
    const current = Array.isArray(value[row]) ? (value[row] as string[]) : []
    onChange({
      ...value,
      [row]: current.includes(column)
        ? current.filter((item) => item !== column)
        : [...current, column],
    })
  }

  return (
    <div className="rounded-lg border border-slate-200 bg-white">
      <div className="flex items-center justify-between gap-3 border-b border-slate-100 px-3 py-2 text-xs text-slate-500">
        <span>{multiple ? '每列可選多個答案' : '每列只能選一個答案'}</span>
        <span className="rounded-full bg-slate-100 px-2 py-1 font-medium text-slate-600">
          {multiple ? '多選矩陣' : '單選矩陣'}
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[520px] text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              <th className="p-3 text-left">項目</th>
              {columns.map((column) => (
                <th key={column} className="p-3 text-center">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={`${row}-${rowIndex}`} className="border-b border-slate-100 hover:bg-sky-50">
                <td className="p-3 font-medium">{row}</td>
                {columns.map((column) => (
                  <td key={column} className="p-3 text-center">
                    <input
                      type={multiple ? 'checkbox' : 'radio'}
                      name={`${question.id}-${rowIndex}`}
                      checked={
                        multiple
                          ? Array.isArray(value[row]) && (value[row] as string[]).includes(column)
                          : value[row] === column
                      }
                      onChange={() => toggle(row, column)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
